module.exports = __webpack_public_path__ + "img/lucky-wheel.adb08d67.svg";